import React from 'react';
import PropTypes from 'prop-types';
import './InputControl.scss';

const InputControl = ({
  placeholder,
  initialValue,
  onValueChanged,
  type,
  label,
  onKeyDown,
  errorMessage,
  isErrorShown,
  value,
}) => (
  <div className="form-group">
    {label && (
      <label className="form-label">{label}</label>
    )}
    {type === 'textarea' && (
      <textarea
        className="form-control"
        placeholder={placeholder}
        value={value || initialValue}
        rows={8}
        onChange={(e) => {
          if (onValueChanged) {
            onValueChanged(e.target.value);
          }
        }}
        onKeyDown={(ev) => {
          if (onKeyDown) {
            onKeyDown(ev);
          }
        }}
      />
    )}
    {type !== 'textarea' && (
      <input
        className="form-control"
        placeholder={placeholder}
        value={value || initialValue}
        type={type}
        onChange={(e) => {
          if (onValueChanged) {
            onValueChanged(e.target.value);
          }
        }}
        onKeyDown={(ev) => {
          if (onKeyDown) {
            onKeyDown(ev);
          }
        }}
      />
    )}
    {errorMessage && isErrorShown && (
      <div className="error-container">
        <small>{errorMessage}</small>
      </div>
    )}
  </div>
);

InputControl.propTypes = {
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
  onValueChanged: PropTypes.func,
  type: PropTypes.string,
  label: PropTypes.string,
  onKeyDown: PropTypes.func,
  errorMessage: PropTypes.string,
  isErrorShown: PropTypes.bool,
  value: PropTypes.string,
};

InputControl.defaultProps = {
  placeholder: undefined,
  initialValue: undefined,
  onValueChanged: undefined,
  type: 'text',
  label: undefined,
  onKeyDown: undefined,
  errorMessage: undefined,
  isErrorShown: false,
  value: undefined,
};

export default InputControl;
